<div class="slider-wrapper" #sliderWrapper>
  <button (click)="prev()" class="slider-nav prev">&lt;</button>

  <div class="slider-viewport">
    <div class="slider-container" #sliderContainer>
      @for (logo of logos; track logo) {
        <div class="slide" [style.min-width.%]="100/visibleCount">
          <div class="logo-holder">
            <img [src]="logo" />
          </div>
        </div>
      }
    </div>
  </div>

  <button (click)="next()" class="slider-nav next">&gt;</button>
</div>